import React from 'react'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import Grid from 'material-ui/Grid'
import { withStyles } from 'material-ui/styles'
import DonutChart from 'components/Donut'
import FundsTable from 'components/FundsTable'
import HistoryAreaChart from 'components/HistoryAreaChart'
import { scaleOrdinal, schemeCategory20c } from 'd3-scale'
import compose from 'recompose/compose'
import grey from 'material-ui/colors/grey'
import { togglePresentation } from 'actions/dashboard'
import Konami from 'components/Konami'
import HighlightedCurrencyLegend from 'components/HighlightedCurrencyLegend'

const styles = theme => ({
  root: {
    [theme.breakpoints.up('md')]: {
      padding: `0 ${theme.spacing.unit * 5}px`,
    },
    [theme.breakpoints.down('md')]: {
      padding: `0 ${theme.spacing.unit * 2}px`,
    },
  },
  OverviewText: {
    maxWidth: 600,
    margin: 'auto',
    textAlign: 'center',
    marginBottom: 20,
  },
  alignCenter: {
    alignSelf: 'center',
    flexGrow: 1,
  },
  donutAndHL: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
  },
  donut: {
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 370,
  },
})

export const colors = scaleOrdinal().range(schemeCategory20c)

class Dashboard extends React.Component {
  state = {
    graphHeight: undefined,
  }
  componentDidUpdate() {
    if (!this.props.doNotResize) {
      this.resize()
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }
  componentDidMount() {
    if (!this.props.doNotResize) {
      this.resize()
      window.addEventListener('resize', this.resize)
    }
  }
  togglePresentation = () => {
    this.props.togglePresentation()
  }
  resize = () => {
    if (this.historyGraph) {
      const top = this.historyGraph.offsetTop
      const height = window.innerHeight - top - 10
      const newHeight = height > 150 ? height : undefined
      if (this.state.graphHeight !== newHeight) {
        this.setState({ graphHeight: newHeight })
      }
    }
  }
  getColorScale = () => {
    let colorsScale
    const { highlightedCurrencies, funds } = this.props
    if (highlightedCurrencies.length === 0) {
      colorsScale = colors
    } else {
      const domain = [
        highlightedCurrencies,
        ...funds
          .map(d => d.currency)
          .filter(d => highlightedCurrencies.indexOf(d) > -1),
      ]
      const range = [
        ...highlightedCurrencies.map(
          d => schemeCategory20c[funds.findIndex(f => f.currency === d)]
        ),
        grey[200],
        grey[300],
        grey[400],
        grey[500],
        grey[600],
        grey[700],
        grey[800],
        grey[800],
        grey[800],
        grey[800],
        grey[800],
        grey[800],
        grey[800],
        grey[800],
        grey[800],
      ]
      colorsScale = scaleOrdinal()
        .range(range)
        .domain(domain)
    }
    return colorsScale
  }
  render() {
    const { funds, mainCurrency, classes, history } = this.props
    const colorsScale = this.getColorScale()
    return (
      <div className={classes.root}>
        <Konami code={[80]} callback={() => this.togglePresentation()} />
        <Grid container>
          <Grid item xs={12} md={8} xl={10}>
            <div className={classes.donutAndHL}>
              <HighlightedCurrencyLegend colour={colorsScale} />
              <DonutChart
                width={500}
                height={500}
                funds={funds}
                className={classes.donut}
                mainCurrency={mainCurrency}
                colors={colorsScale}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4} xl={2}>
            <FundsTable colour={colorsScale} />
          </Grid>
          <Grid item xs={12}>
            <div ref={ref => (this.historyGraph = ref)}>
              {Object.keys(history).length > 0 && (
                <div>
                  <HistoryAreaChart
                    height={this.state.graphHeight}
                    funds={funds}
                    history={history}
                    colors={colorsScale}
                  />
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  funds: selectors.fundsWithValueMergedByCrypto(state),
  history: selectors.historics(state),
  mainCurrency: selectors.mainCurrency(state),
  isAuthentified: selectors.isAuthentified(state),
  highlightedCurrencies: selectors.highlightedCurrencies(state),
})

const mapDispatchToProps = dispatch => ({
  togglePresentation: () => dispatch(togglePresentation()),
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Dashboard)



// WEBPACK FOOTER //
// ./src/components/Dashboard.js